export default __webpack_public_path__ + "static/media/footerUno.49c1fef5.jpeg";